import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAPICall } from '../../hooks';
import { Loading } from '../../ui/components';
import { LoggerService } from '../../ui/utils';
import CampaignService from '../../sdk/services/campaignService';
import ScratchGame from './scratchGame/ScratchGame';
import SpinWheel from './spinWheel/SpinWheel';

export default function GameRouter() {
  const [searchParams] = useSearchParams();
  const apiCall = useAPICall();
  const [gameType, setGameType] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const campaignId = searchParams.get('id');

  useEffect(() => {
    const fetchCampaignDetails = async () => {
      if (!campaignId) {
        // Default to scratch game if no campaign ID
        setGameType('scratchWin');
        setLoading(false);
        return;
      }

      try {
        const result = await apiCall(CampaignService.getCampaignDetailByCampaignId, campaignId);
        
        if (result?.data?.data) {
          const configJson = result.data.data.configJson;
          // Check if gameType exists in configJson, default to scratchWin
          const type = configJson?.gameType || 'scratchWin';
          setGameType(type);
          
          // Store campaign name for later use
          if (result.data.data.campaignName) {
            localStorage.setItem('campaignName', result.data.data.campaignName);
          }
        } else {
          // Default to scratch game if campaign not found
          setGameType('scratchWin');
        }
      } catch (error) {
        LoggerService.log('Error fetching campaign details:', error);
        // Default to scratch game on error
        setGameType('scratchWin');
      } finally {
        setLoading(false);
      }
    };

    fetchCampaignDetails();
  }, [campaignId]);

  if (loading) {
    return <Loading />;
  }

  // Route to appropriate game based on gameType
  if (gameType === 'spinWheel') {
    console.log("Redirecting to SpinWheel..");
    return <SpinWheel />;
  }

  // Default to ScratchGame
  return <ScratchGame />;
}
